import { useState } from "react";
import NitroService from "../../utils/nitro.service";

import { sort } from "../../utils/Sort";
import NitroFilter from "../NitroFilter";

const CityFilter = ({
  value,
  setValue,
  disabled,
  size,
  setZipCodes,
  isMobile,
}: {
  value: string;
  setValue: (value: string) => void;
  disabled?: boolean;
  size?: "small" | "medium";
  setZipCodes?: (zipCodes: string[]) => void;
  isMobile?: boolean;
}) => {
  const [records, setRecords] = useState<
    { id: string; name: string; zipCodes: string[] }[]
  >([]);

  const getRecords = async (v: string) => {
    const newRecords = await NitroService.getCityStates(v);
    setRecords(newRecords);
    return [
      // "",
      ...newRecords
        .filter((r) => !!r)
        .map((r) => {
          return { label: r.name, value: r.name };
        }),
    ];
  };

  return (
    <NitroFilter
      data={{ getRecords }}
      value={value}
      setValue={(v) => {
        if (setZipCodes) {
          const zipCodes = records.find((r) => r.name === v)?.zipCodes || [];
          setZipCodes(sort(zipCodes, "ASC"));
        }
        setValue(v || "");
      }}
      disabled={disabled}
      size={size}
      isMobile={isMobile}
      type="autocomplete"
      placeholder="City"
      autocompleteOptions={{
        filterOptions: (r: any) => {
          return r;
        },
      }}
    />
  );
};

export default CityFilter;
